import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const Analytics = () => {
    const location = useLocation();

    useEffect(() => {
        // Initialize GA4 with Measurement ID from environment variable
        const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

        if (measurementId) {
            ReactGA.initialize(measurementId);
        } else {
            console.warn('Google Analytics not initialized. Add REACT_APP_GA_MEASUREMENT_ID to .env');
        }
    }, []);

    useEffect(() => {
        // Track page views on route change
        const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
        if (measurementId && measurementId !== 'G-XXXXXXXXXX') {
            ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
        }
    }, [location]);

    return null; // This component doesn't render anything
};

export default Analytics;
